import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_" + process.env.NODE_ENV);

Vue.use(Router);
import Layout from "../views/layout/Layout";
import Login from "../views/login/index.vue";
import sMap from "../views/H5/sMap.vue";
import jqMap from "../views/H5/jqMap.vue";
import outboundMap from "../views/H5/outboundMap.vue";

export const constantRouterMap = [
  {
    path: "/",
    // redirect: "/index/home",
    redirect: '/orderManege/orderManege',
    // name: 'HelloWorld',
    component: Layout
  },
  {
    path: "/sMap",
    // redirect: "/index/home",
    name: 'sMap',
    component: sMap,
    meta:{
      web_title:'供应商送货排行'
    }
  },
  {
    path: "/jqmap",
    // redirect: "/index/home",
    name: 'jqMap',
    component: jqMap,
    meta:{
      web_title:'卖货排行'
    }
  },
  {
    path: "/outboundmap",
    // redirect: "/index/home",
    name: 'outboundMap',
    component: outboundMap,
    meta:{
      web_title:'出库排行'
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  // {
  //   path: "/index",
  //   redirect: "/index/home",
  //   component: Layout,
  //   name: "index",
  //   meta: {
  //     title: "home",
  //     icon: "zhengzhi"
  //   },
  //   children: [
  //     {
  //       path: "home",
  //       component: _import("home/index"),
  //       name: "home",
  //       meta: { title: "home", icon: "zhengzhi" }
  //     }
  //   ]
  // },
  {
    path: "/orderManeges",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "orderManege", icon: "icon" },
    children: [
      {
        path: "empty",
        component: _import("order/empty"),
        name: "empty",
        meta: { title: "orderManege", icon: "icon" }
      }
    ]
  }
  // {
  //   path: '/client',
  //   component: Layout,
  //   name: 'client',
  //   meta: {
  //     title: 'client',
  //     icon: 'client'
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       component: _import('client/list'),
  //       name: 'list',
  //       meta: {title: 'list', icon: 'list'}
  //     },
  //     {
  //       path: 'BD',
  //       component: _import('client/bd'),
  //       name: 'bd',
  //       meta: {title: 'bd', icon: 'bd'}
  //     },
  //     {
  //       path: 'industry',
  //       component: _import('client/industry'),
  //       name: 'industry',
  //       meta: {title: 'industry', icon: 'industry'}
  //     },
  //   ]
  // },
];

export const asyncRouterMap = [
  {
    path: "/offerManege",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "offerManege", icon: "gongdan" },
    children: [
      {
        path: "offerManege",
        component: _import("info/offer"),
        name: "offerForm",
        meta: { title: "offerManege", icon: "gongdan", noCache: true }
      }
    ]
  },
  {
    path: "/orderManege",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "orderManege", icon: "neirong" },
    children: [
      {
        path: "orderManege",
        component: _import("order/index"),
        name: "orderForm",
        meta: { title: "orderManege", icon: "neirong" }
      }
    ]
  },
  {
    path: "/userManege",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "userManege", icon: "yonghu" },
    children: [
      {
        path: "userManege",
        component: _import("info/user"),
        name: "userForm",
        meta: { title: "userManege", icon: "yonghu", noCache: true }
      }
    ]
  },
  {
    path: "/wasteManege",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "wasteManege", icon: "order" },
    children: [
      {
        path: "wasteManege",
        component: _import("info/waste"),
        name: "wasteForm",
        meta: { title: "wasteManege", icon: "order", noCache: true }
      }
    ]
  },
  {
    path: "/pointManege",
    component: Layout,
    name: "pointManege",
    redirect:'/pointManege/streeManege',
    meta: { title: "pointManege", icon: "shezhi", noCache: true ,fid:2},
    children: [
      {
        path: "streeManege",
        component: _import("stree/index"),
        name: "streeForm",
        meta: { title: "streeManege", icon: "jiedao", noCache: true }
      },
      {
        path: "siteManege",
        component: _import("site/index"),
        name: "siteForm",
        meta: { title: "siteManege", icon: "zhandian", noCache: true }
      }
    ]
  },
  {
    path: "/comprehensiveManege",
    component: Layout,
    name: "comprehensiveManege",
    redirect:'/comprehensiveManege/collectorManege',
    meta: { title: "comprehensiveManege", icon: "yg-guanli", noCache: true,fid:3 },
    children: [
      {
        path: "collectorManege",
        component: _import("comprehensive/collector"),
        name: "collectorForm",
        meta: { title: "collectorManege", icon: "huishou", noCache: true }
      },
      {
        path: "permissionsManege",
        component: _import("comprehensive/powers"),
        name: "permissionsForm",
        meta: { title: "permissionsManege", icon: "quanxian", noCache: true }
      }
    ]
  },
  {
    path: "/feedbackManege",
    component: Layout,
    // name: 'orderForms',
    meta: { title: "feedbackManege", icon: "question" },
    children: [
      {
        path: "feedbackManege",
        component: _import("info/feedback"),
        name: "feedbackForm",
        meta: { title: "feedbackManege", icon: "question", noCache: true }
      }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    name: 'financeForms',
    meta: {title: 'finance', icon: 'icon',fid:12},
    children: [
      {
        path: 'consumption',
        component: _import('finance/consumption'),
        name: 'consumption',
        meta: {title: 'consumption', icon: 'icon', noCache: true}
      },
      {
        path: 'recharge',
        component: _import('finance/recharge'),
        name: 'recharge',
        meta: {title: 'recharge', icon: 'icon', noCache: true}
      }
    ]
  },
  {
    path: "/banner",
    component: Layout,
    name: "bannerForms",
    redirect:'/banner/bannerList',
    meta: { title: "banner", icon: "zixun",fid:15 },
    children: [
      {
        path: "bannerList",
        component: _import("banner/bannerList"),
        name: "bannerList",
        meta: { title: "bannerList", icon: "zixun", noCache: true }
      },
      {
        path: "bannerAdd",
        component: _import("banner/bannerAdd"),
        name: "bannerAdd",
        meta: { title: "bannerAdd", icon: "icon", noCache: true },
        hidden: true
      },
      {
        path: "bannerEdit",
        component: _import("banner/bannerAdd"),
        name: "bannerEdit",
        meta: { title: "bannerEdit", icon: "icon", noCache: true },
        hidden: true
      },
      {
        path: "bannerDetails",
        component: _import("banner/bannerDetails"),
        name: "bannerEdit",
        meta: { title: "bannerDetails", icon: "icon", noCache: true },
        hidden: true
      }
    ]
  }
];

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js